import { createSlice } from '@reduxjs/toolkit';
import { addQuestionPaper, getEachQuestionPaper, getQuestionPaper, getQuestions, removeQuestionPaper } from 'services/store/actions/questionPaperAction';
import { getCandidDashboard, getDashboard, getDashboardInfo } from '../actions/dashboardAction';

interface QusPaperState {
    loading: boolean;
    dashCandidInfo: any; // Define the type of userInfo
    error: any; // Define the type of error
    success: boolean;
    loading1: boolean;
    dashboardInfo: any;
    error1: any;
    success1: boolean;
    loading2: boolean;
    dashInfo: any;
    error2: any;
    success2: boolean;
    //get question data
    loading3: boolean;
    quesPaperInfo: any;
    error3: any;
    success3: boolean;
    //get each question
    loading4: boolean;
    paperInfo: any;
    error4: any;
    success4: boolean;
}

const initialState: QusPaperState = {
    loading: false,
    dashCandidInfo: null,
    error: null,
    success: false,
    loading1: false,
    dashboardInfo: null,
    error1: null,
    success1: false,
    loading2: false,
    dashInfo: null,
    error2: null,
    success2: false,
    //each question paper
    success3: false,
    loading3: false,
    quesPaperInfo: null,
    error3: null,
    loading4: false,
    paperInfo: null,
    error4: null,
    success4: false,
};

const dashboardSlice = createSlice({
    name: 'dashboardSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getCandidDashboard.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
                state.dashCandidInfo = null;
            })
            .addCase(getCandidDashboard.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.dashCandidInfo = payload;
                state.success = true;
            })
            .addCase(getCandidDashboard.rejected, (state, { payload }) => {
                state.loading = false;
                state.error = payload;
                state.success = false;
            })
            .addCase(getDashboardInfo.pending, (state) => {
                state.loading1 = true;
                state.error1 = null;
                state.success1 = false;
                state.dashboardInfo = null;
            })
            .addCase(getDashboardInfo.fulfilled, (state, { payload }) => {
                state.loading1 = false;
                state.dashboardInfo = payload;
                state.success1 = true;
            })
            .addCase(getDashboardInfo.rejected, (state, { payload }) => {
                state.loading1 = false;
                state.error1 = payload;
                state.success1 = false;
            })
            .addCase(getDashboard.pending, (state) => {
                state.loading2 = true;
                state.error2 = null;
                state.success2 = false;
                state.dashInfo = null;
            })
            .addCase(getDashboard.fulfilled, (state, { payload }) => {
                state.loading2 = false;
                state.dashInfo = payload;
                state.success2 = true;
            })
            .addCase(getDashboard.rejected, (state, { payload }) => {
                state.loading2 = false;
                state.error2 = payload;
                state.success2 = false;
            })
    }
});

export default dashboardSlice.reducer;